// extracted by mini-css-extract-plugin
export var section = "featured-title-module--section--06658";
export var title = "featured-title-module--title--1eeb4";